import Vuex from 'vuex';
import auth from '../auth';
import catalog from './modules/catalog';
import cart from './modules/cart';
import company from './modules/company';
import system from './modules/system';

const calculateOptionsPrice = (list, quantityOfIncludedOptions = 0) => {
  if (!list || list.length === 0) {
    return 0;
  }
  let listFormatted = [];
  const cumulativeFree = {};
  let addedFree = 1;
  list.forEach((option) => {
    if (option.name.en) {
      cumulativeFree[option.name.en] = 0;
    } else {
      cumulativeFree[option.name.de] = 0;
    }
    if (option.quantity === 1) {
      listFormatted.push(option);
    } else {
      for (let i = 0; i < option.quantity; i += 1) {
        listFormatted.push(option);
      }
    }
  });
  listFormatted = listFormatted.sort((a, b) => a.price - b.price);
  let cumulativePrice = 0;
  if (Array.isArray(list) && list.length > 0) {
    if (listFormatted.length > 0 && quantityOfIncludedOptions > 0) {
      listFormatted.forEach((option) => {
        if (option.name.en) {
          cumulativeFree[option.name.en] += 1;
        } else {
          cumulativeFree[option.name.de] += 1;
        }
        // eslint-disable-next-line no-param-reassign
        if (option.maxIncludedQuantity === undefined) option.maxIncludedQuantity = 0;
        if (addedFree > quantityOfIncludedOptions
          || (option.name.en && cumulativeFree[option.name.en] > option.maxIncludedQuantity)
          || (option.name.de && cumulativeFree[option.name.de] > option.maxIncludedQuantity)) {
          cumulativePrice += option.price;
        } else {
          addedFree += 1;
        }
      });
      return cumulativePrice;
    } else if (listFormatted.length > 0 && quantityOfIncludedOptions === 0) {
      return listFormatted.reduce((a, b) => a + (b.price || 0), 0);
    }
    return cumulativePrice;
  }
  return cumulativePrice;
};

export default () => new Vuex.Store({
  state: {
    err: '',
    baseUrl: process.env.NODE_ENV === 'development' ? 'http://localhost:3000/' : '/',
    isLoggedIn: auth.isLoggedIn,
    logout: auth.logout,
    calculatePrice(size, variant, options, quantity, quantityOfIncludedOptions = 0) {
      const sizePrice = size.price;
      const variantPrice = variant ? variant.price || 0 : 0;
      const optionsPrice = calculateOptionsPrice(options || [], quantityOfIncludedOptions || 0);
      return (sizePrice + variantPrice + optionsPrice) * quantity;
    },
  },
  modules: {
    catalog,
    cart,
    company,
    system,
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js